import { Carousel } from 'antd';
import styled from 'styled-components';
import { useGetPhotoQuery } from '@/services/general-api';
import Loading from '@/components/loading';

const W = 200;
const H = 300;

const PhotoWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${W}px;
  height: ${H}px;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: top;
  }
`;

const Photo = ({ photoId, fileName }) => {
  const { data, isLoading } = useGetPhotoQuery({ photoId, width: H });
  return (
    <PhotoWrapper>
      {isLoading ? <Loading size="default" /> : <img src={`data:image/jpeg;base64,${data}`} alt={fileName} />}
    </PhotoWrapper>
  );
};

const Photos = ({ items }) => {
  return (
    <Carousel autoplay style={{ width: W, height: H, background: 'rgba(0, 0, 0, 0.1)' }}>
      {items?.map((item) => (
        <Photo key={item.blobId} photoId={item.blobId} fileName={item.fileName} />
      ))}
    </Carousel>
  );
};

export default Photos;
